import { createContext } from 'react'

import { action, autorun, makeAutoObservable } from 'mobx'

import {
  GetProductsListQuery,
  NumberFromToFilter,
  NumberOneOfFilter,
  ProductsListOrderType,
  StringExactFilter,
  StringOneOfFilter,
  StringTermFilter,
} from '../../api/generated'

export class FilterStorage {
  criteriaCategoryId?: number
  sorting: GetProductsListQuery =
    // localStorage.sorting
    //   ? JSON.parse(localStorage.sorting)
    //   :
    { dayPriceFrom: 0, dayPriceTo: 0, premiumOnly: false }
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
    // autorun(() => {
    //   localStorage.sorting = JSON.stringify(this.sorting)
    // })
  }
  @action clear() {
    this.sorting = {
      dayPriceFrom: 0,
      dayPriceTo: 0,
      premiumOnly: false,
      ratingFrom: 0,
    }
  }

  @action
  setDayPriceFrom(data: number) {
    this.sorting.dayPriceFrom = data
  }

  @action
  setDayPriceTo(data: number) {
    this.sorting.dayPriceTo = data
  }

  @action
  setHighRatingOnly(data: boolean) {
    data ? (this.sorting.ratingFrom = 4) : (this.sorting.ratingFrom = 0)
  }

  @action
  setOrderBy(data: ProductsListOrderType) {
    this.sorting.orderType = data
  }

  @action
  setPremiumOnly(data: boolean) {
    this.sorting.premiumOnly = data
  }

  @action
  setStringOneOfFilter(criterionId: number, values: string[]) {
    this.sorting.stringOneOfFilters = this.upsertCriterionFilter<StringOneOfFilter>(
      this.sorting.stringOneOfFilters,
      criterionId,
      values.length ? { criterionId, values } : null
    )
  }

  @action
  setNumberOneOfFilter(criterionId: number, values: number[]) {
    this.sorting.numberOneOfFilters = this.upsertCriterionFilter<NumberOneOfFilter>(
      this.sorting.numberOneOfFilters,
      criterionId,
      values.length ? { criterionId, values } : null
    )
  }

  @action
  setStringValueFilter(type: 'stringExact' | 'stringTerm', criterionId: number, value?: string) {
    const key = type === 'stringExact' ? 'stringExactFilters' : 'stringTermFilters'
    const filters = this.sorting[key]
    const next = this.upsertCriterionFilter<StringExactFilter | StringTermFilter>(
      filters,
      criterionId,
      value ? { criterionId, value } : null
    )
    if (type === 'stringExact') this.sorting.stringExactFilters = next
    else this.sorting.stringTermFilters = next
  }

  @action
  setNumberFromToFilter(criterionId: number, valueFrom?: number, valueTo?: number) {
    const hasValue = valueFrom !== undefined || valueTo !== undefined
    this.sorting.numberFromToFilters = this.upsertCriterionFilter<NumberFromToFilter>(
      this.sorting.numberFromToFilters,
      criterionId,
      hasValue ? { criterionId, valueFrom, valueTo } : null
    )
  }

  @action
  clearCriteriaFilters() {
    this.sorting.stringOneOfFilters = []
    this.sorting.stringExactFilters = []
    this.sorting.stringTermFilters = []
    this.sorting.numberOneOfFilters = []
    this.sorting.numberFromToFilters = []
  }

  @action
  prepareCriteriaForCategory(categoryId: number) {
    if (this.criteriaCategoryId === categoryId) return
    this.clearCriteriaFilters()
    this.criteriaCategoryId = categoryId
  }

  private upsertCriterionFilter<T extends { criterionId?: number }>(
    filters: T[] | null | undefined,
    criterionId: number,
    nextFilter: T | null
  ) {
    const next = (filters ?? []).filter(filter => filter.criterionId !== criterionId)
    return nextFilter ? [...next, nextFilter] : next
  }

  @action
  setSorting(data: GetProductsListQuery) {
    this.sorting = data
  }

  get isHighRatingOnly() {
    return this.sorting.ratingFrom > 3
  }
  get isPremiumOnly() {
    return this.sorting.premiumOnly
  }

  get orderType() {
    return this.sorting.orderType
  }
}

export default createContext(new FilterStorage())
